import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Col, Row } from 'react-bootstrap-5';

import type { Ownerships } from 'bundles/connect/types';
import AiBadge from '../../call_list/owners/ai_badge';
import LlcMatchBadge from '../../call_list/owners/llc_match_badge';
import AssessorMatchBadge from '../../call_list/owners/assessor_match_badge';
import { faEnvelope, faMobileScreen, faPhone, faPhoneOffice } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import AiFeedback from '../../feedback/ai_feedback';

type Props = {
  owners: Ownerships[];
}

const phoneLabelIconMap = {
  Business: faPhoneOffice,
  Mobile: faMobileScreen,
  Default: faPhone
};

const phoneIcon = (label: string) => {
  const icon = phoneLabelIconMap[label] || phoneLabelIconMap.Default;
  return <FontAwesomeIcon className="text-muted py-1" icon={icon} size="sm" />;
};

export default function HighestConfidenceOwners({ owners }: Props) {
  if (owners.length < 1) return null;

  return (
    <div className="d-flex flex-column gap-3">
      <div className="fs-large fw-bolder">Highest Confidence</div>
      <Row className="g-3">
        {owners.map(owner => (
          <Col className="d-flex flex-column gap-0-5" key={owner.id} md={6} xs={12} >
            <div className={classNames('rounded p-3', owner.aiVerified ? 'ai-section' : 'bg-light')}>
              <div className="d-flex flex-column gap-2">
                <Row>
                  <Col className="d-flex gap-1">
                    {owner.aiVerified && <AiBadge sources={owner.aiSources || []} verified />}
                    {owner.llcMatch && <LlcMatchBadge />}
                    {owner.assessorMatch && <AssessorMatchBadge />}
                  </Col>
                  {owner.aiVerified && (
                    <Col xs="auto">
                      <AiFeedback fromConsole={false} obj={owner} objType="Connect::Ownership" />
                    </Col>
                  )}
                </Row>
                <h6 className="text-body privacy-mask mb-0">{owner.contact.name}</h6>
              </div>
              {owner.contact.jobTitle && <small>{owner.contact.jobTitle}</small>}
            </div>
            <div>
              <Row className="gap-1 m-0">
                {owner.contact.phoneNumbers.slice(0, 3).map(phoneNumber => (
                  <Col
                    className={classNames('d-flex gap-1 rounded p-3', owner.aiVerified ? 'ai-section' : 'bg-light')}
                    key={phoneNumber.id}
                  >
                    {phoneIcon(phoneNumber.label)}
                    <div>
                      <a className="fs-small" href={phoneNumber.number}>{phoneNumber.formatted}</a>
                      <div className="fs-x-small text-muted">{phoneNumber.label}</div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <div className={classNames('rounded p-3 d-flex gap-1', owner.aiVerified ? 'ai-section' : 'bg-light')}>
              <FontAwesomeIcon className="text-muted py-1" icon={faEnvelope} size="sm" />
              {owner.contact.emails.length > 0 && (
                <a className="fs-small" href={owner.contact.emails[0].email}>{owner.contact.emails[0].email}</a>
              )}
              {owner.contact.emails.length === 0 && (
                <span className="fs-small text-muted">No email address</span>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
